// theme constant
export const gridSpacing = 3;
export const drawerWidth = 300;
export const appDrawerWidth = 320;
const LAYOUT_CONST = {
  VERTICAL_LAYOUT: "vertical",
  HORIZONTAL_LAYOUT: "horizontal",
  DEFAULT_DRAWER: "default",
  MINI_DRAWER: "mini-drawer",
};

export default LAYOUT_CONST;
export const MINIMUM_INTEGER_COUNT = 2;

export const DEFAULT_ROWS_PER_PAGE = 10;

export const DEFAULT_TOTAL_ITEMS = 0;

export const DEFAULT_ITEMS = "items";

export const DEFAULT_HOUR = 0;
export const MAX_HOUR = 24;
